




























































import { Vue, Component, Watch } from 'vue-property-decorator'
import { State, Action, namespace } from 'vuex-class'
@Component
export default class ResultShow extends Vue {
  imgUrl: string = ''
  text: any = ''
  active: any = 0
  errorData: any = { src: require('../../../../assets/images/error.png') }
  payingData: any = { src: require('../../../../assets/images/loading.png') }
  created() {
    if (this.$route.query.status == 'error') {
      this.imgUrl = this.errorData['src']
      this.text = this.$route.query.text
    } else if (this.$route.query.status == 'paying') {
      this.imgUrl = this.payingData['src']
      this.text = this.$route.query.text
    }else{
      this.text = this.$route.query.text
    }
  }
  buttonClick() {
    this.$router.replace({ path: '/billManage', query: { billMonth: this.$route.query.billMonth } })
  }
}
